'use strict';

var _hasClass = require('./hasClass');

var _hasClass2 = _interopRequireDefault(_hasClass);

var _removeClass = require('./removeClass');

var _removeClass2 = _interopRequireDefault(_removeClass);

var _mixClass = require('./mixClass');

var _mixClass2 = _interopRequireDefault(_mixClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toggleClass = function toggleClass(classes, name) {
    if ((0, _hasClass2.default)(classes, name)) {
        classes = (0, _removeClass2.default)(classes, name);
    } else {
        classes = (0, _mixClass2.default)(classes, name);
    }
    return classes;
};